import { endpointsList } from '@/helpers';
import { IWorkspaceDocumentUpdateInfoDto } from 'types';
import axios from 'axios';

export function useWorkspaceDocumentUpdateInfo() {
  async function getWorkspaceDocumentUpdateInfo(params: {
    workspaceId: string;
    documentId: string;
  }): Promise<IWorkspaceDocumentUpdateInfoDto> {
    const { workspaceId, documentId } = params;
    const response = await axios.get<IWorkspaceDocumentUpdateInfoDto>(
      endpointsList.workspaceUploads.getWorkspaceDocumentUpdateInfo(
        workspaceId,
        documentId,
      ),
    );

    return response.data;
  }

  return { getWorkspaceDocumentUpdateInfo };
}
